function formHandler(selector) {
  var form = document.querySelector(selector || "[data-form]");
  
  async function handleSubmit(event) {
    event.preventDefault();
    
    try {
      // Add loading state
      form.classList.add('loading');
      form.classList.remove('success', 'error');

      // Get form data
      const formData = new FormData(form);
      
      // Send the request
      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
        redirect: 'manual'
      });

      if (!response.ok && response.type !== 'opaqueredirect') {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Handle success
      form.classList.remove('loading');
      form.classList.add('success');
      form.reset();
    } catch (error) {
      // Handle error
      console.error('Form submission error:', error);
      form.classList.remove('loading');
      form.classList.add('error');
    }
  }

  if (form) {
    form.addEventListener("submit", handleSubmit);
  }
}
